const roleOf = (user) => user?.role?.toString().trim().toLowerCase() || ''
export const canUseMyQueue = (user) => ['sales', 'owner', 'admin'].includes(roleOf(user))
const baseCanUseAuditQueue = (user) => ['owner', 'admin'].includes(roleOf(user))

// Delegated IG Story swap access (UI only; Rails API always enforces permissions).
const IG_STORY_DELEGATED_SWAP_ACCOUNT = 'angel@belleandkate.com'
export const canUseAuditQueue = (user) => {
  const email = String(user?.email || user?.administrator?.email || user?.admin?.email || '').trim().toLowerCase()
  return baseCanUseAuditQueue(user) || (email === IG_STORY_DELEGATED_SWAP_ACCOUNT && user?.active !== false)
}
